module.exports = fox._r("images/bg-404.jpg", __webpack_public_path__ + "images/bg-404.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/bg-404.jpg
// module id = 501
// module chunks = 2